import http from 'utils/http';
import { getWebhookEventsUrl, getWebhookLogUrl, getWebhookLogsUrl, getWebhookUrl, getWebhooksUrl } from './apiUrls';
import {
  Webhook,
  WebhookEventsResponse,
  WebhookLog,
  WebhookLogsResponse,
  WebhookRequest,
  WebhooksResponse
} from './types';

export function getWebhooks(params?: Record<string, unknown>): Promise<WebhooksResponse> {
  return http.get(getWebhooksUrl(), params);
}

export function getWebhook(webhookId: string): Promise<Webhook> {
  return http.get(getWebhookUrl(webhookId));
}

export function getWebhookEvents(): Promise<WebhookEventsResponse> {
  return http.get(getWebhookEventsUrl());
}

export function createWebhook(payload: WebhookRequest): Promise<Webhook> {
  return http.post(getWebhooksUrl(), payload);
}

export function updateWebhook(webhookId: number, payload: WebhookRequest): Promise<Webhook> {
  return http.put(getWebhookUrl(webhookId), payload);
}

export function deleteWebhook(webhookId: number): Promise<void> {
  return http.delete(getWebhookUrl(webhookId));
}

export function getWebhookLogs(params?: Record<string, unknown>): Promise<WebhookLogsResponse> {
  return http.get(getWebhookLogsUrl(), params);
}

export function getWebhookLog(logId: string): Promise<WebhookLog> {
  return http.get(getWebhookLogUrl(logId));
}
